export default "__VITE_ASSET__NDC6ndRc__"